import * as React from "react";

import { cn } from "@/lib/utils";

export const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(
      "rounded-md border bg-card px-4 py-3 text-sm text-card-foreground",
      className
    )}
    {...props}
  />
));

Alert.displayName = "Alert";
